<template>
    <div
        class="bg-white rounded px-7 pt-7 pb-4 mt-10 shadow-card"
    >
        <div class="inline-flex items-center">
            <a :href="route('send.index')">
                <i class="fas text-xs fa-arrow-left mr-3 cursor-pointer" />
            </a>
            <h4>Digite a chave copia e cola</h4>
        </div>

        <div class="mt-6 ml-1 relative">
            <h5 class="text-xs">Chave Pix</h5>
            <jet-input
                id="payer_name"
                type="text"
                class="mt-1 block w-full text-md"
                placeholder="Digite a chave copia e cola"
                v-model.trim="key"
                @blur.native="errorKey = ''"
                @keydown.enter.native="validateKey"
            />
            <jet-input-error :message="errorInput" class="absolute bottom-8" />

            <div class="w-full flex justify-end items-center mt-5 mb-1">
                <button
                    class="bg-green-500 hover:bg-green-600 text-white text-xs leading-none p-3 rounded flex"
                    :class="loadingInfoKey ? 'cursor-not-allowed': ''"
                    :disabled="loadingInfoKey"
                    @click="validateKey"
                >
                    <div v-show="loadingInfoKey" class="text-right mr-2">
                        <i class="fas fa-spinner animate-spin" />
                    </div>
                    Prosseguir com esta chave
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";

import Favored from "../components/Favored.vue";

export default {
    name: 'SelectKeyCopyPaste',
    props: {
        contacts: { type: Object, default: () => ({}) },
        getInfoKey: { type: Function, required: true }
    },
    data(){
        return {
            key: '',
            contactSelected: {},
            errorKey: '',
            removeConfirm: false,
            loadingInfoKey: false,
            form: this.$inertia.form({
                _method: 'DELETE'
            })
        }
    },
    computed: {
        errorInput(){
            return this.errorKey ? this.errorKey : ''
        }
    },
    methods: {
        async validateKey(){
            if(!this.key) return this.errorKey = 'Digite a chave copia e cola'
            this.errorKey = ''

            this.loadingInfoKey = true
            const error = await this.getInfoKey(this.key)
            if(error) this.errorKey = error
            this.loadingInfoKey = false
        },
    },
    components: {
        JetInput,
        JetInputError,
        Favored
    },
};
</script>
